const layouts = [
  "Customer Care Page",
  "Legal Page",
  "FAQ Answer",
  "Get In Touch",
  "Search Page",
];

export const getLayout = (template: string): boolean => {
  if (!template) {
    return false;
  }
  return layouts.some((layout) => template.match(new RegExp(layout, "i")));
};
